<template>
  <div ref="slider" :class="['nt-slider', active ? 'nt-slider--active' : '']">
    <div class="nt-slider__content" :class="[hasScroll ? 'nt-slider__content--scroll' : '']">
      <div class="ct-medium">
        <div class="items">
          <slot name="first"></slot>
        </div>
      </div>
      <slot name="second"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'nt-slider',
  props: {
    name: {
      type: String
    }
  },
  data() {
    return {
      active: false,
      hasScroll: false
    }
  },
  computed: {
    ...mapGetters(['slider'])
  },
  watch: {
    slider(value) {
      this.active = value.type === this.name && value.active

      if (!this.active) {
        this.hasScroll = this.active
      } else {
        setTimeout(() => {
          this.hasScroll = this.active
        }, 1000)
      }
    },
    active(state) {
      const body = document.querySelector('body')
      const html = document.querySelector('html')

      if (state) {
        body.classList.add('no-scroll')
        html.classList.add('no-scroll')
      } else {
        body.classList.remove('no-scroll')
        html.classList.remove('no-scroll')
      }
    }
  }
}
</script>
